import { render } from "./VerifySignUp.vue?vue&type=template&id=f553088e&scoped=true"
import script from "./VerifySignUp.vue?vue&type=script&lang=js"
export * from "./VerifySignUp.vue?vue&type=script&lang=js"

import "./VerifySignUp.vue?vue&type=style&index=0&id=f553088e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f553088e"],['__file',"src/components/LoginFlow/VerifySignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f553088e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f553088e', __exports__)) {
    api.reload('f553088e', __exports__)
  }
  
  module.hot.accept("./VerifySignUp.vue?vue&type=template&id=f553088e&scoped=true", () => {
    api.rerender('f553088e', render)
  })

}


export default __exports__